import React, { Component } from 'react';
import { Collapse, CardBody, Card } from 'reactstrap';
import { withTranslator } from '../../I18n/withTranslator';
import PropTypes from 'prop-types';

class Faq extends Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = { collapse: false };
  }

  toggle() {
    this.setState((prevState) => ({
      collapse: !prevState.collapse,
    }));
  }

  renderArrow() {
    const DownArrow = this.props.downArrow;

    return (
      <span className={this.state.collapse ? 'collapse-arrow open' : 'collapse-arrow'}>
        <span className="SVGInline">
          <DownArrow />
        </span>
      </span>
    );
  }

  render() {
    return (
      <div className="collapse-item">
        <h3 onClick={this.toggle}>
          {this.props.question}
          {this.renderArrow()}
        </h3>
        <Collapse isOpen={this.state.collapse}>
          <Card>
            <CardBody>{this.props.answer}</CardBody>
          </Card>
        </Collapse>
      </div>
    );
  }
}

Faq.propTypes = {
  question: PropTypes.string.isRequired,
  answer: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  downArrow: PropTypes.element.isRequired,
};

export default withTranslator(Faq);
